import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ILocaleLanguage } from '../interfaces/locale-language.interface';

export const supportedAppLocalesLanguages: List<ILocaleLanguage> = List([
  {
    locale: 'nl-NL',
    language: 'LANGUAGE.NL_NL',
  },
  {
    locale: 'en-AU',
    language: 'LANGUAGE.EN_AU',
  },
  {
    locale: 'en-CA',
    language: 'LANGUAGE.EN_CA',
  },
  {
    locale: 'en-NZ',
    language: 'LANGUAGE.EN_NZ',
  },
  {
    locale: 'en-ZA',
    language: 'LANGUAGE.EN_ZA',
  },
  {
    locale: 'en-GB',
    language: 'LANGUAGE.EN_GB',
  },
  {
    locale: 'en-US',
    language: 'LANGUAGE.EN_US',
  },
  {
    locale: 'fr-CA',
    language: 'LANGUAGE.FR_CA',
  },
  {
    locale: 'fr-FR',
    language: 'LANGUAGE.FR_FR',
  },
  {
    locale: 'de-DE',
    language: 'LANGUAGE.DE_DE',
  },
  {
    locale: 'it-IT',
    language: 'LANGUAGE.IT_IT',
  },
  {
    locale: 'es-MX',
    language: 'LANGUAGE.ES_MX',
  },
  {
    locale: 'es-ES',
    language: 'LANGUAGE.ES_ES',
  },
]);

export const defaultAppLocaleLanguage: ILocaleLanguage = supportedAppLocalesLanguages.find(
  (localeLanguage: ILocaleLanguage) => localeLanguage.locale === 'en-US'
);

export const supportedDocumentLocalesLanguages: List<ILocaleLanguage> = List([
  {
    locale: 'nl-AW',
    language: 'LANGUAGE.NL_AW',
  },
  {
    locale: 'nl-BE',
    language: 'LANGUAGE.NL_BE',
  },
  {
    locale: 'nl-BQ',
    language: 'LANGUAGE.NL_BQ',
  },
  {
    locale: 'nl-CW',
    language: 'LANGUAGE.NL_CW',
  },
  {
    locale: 'nl-AN',
    language: 'LANGUAGE.NL_AN',
  },
  {
    locale: 'nl-NL',
    language: 'LANGUAGE.NL_NL',
  },
  {
    locale: 'nl-SX',
    language: 'LANGUAGE.NL_SX',
  },
  {
    locale: 'nl-SR',
    language: 'LANGUAGE.NL_SR',
  },
  {
    locale: 'en-AS',
    language: 'LANGUAGE.EN_AS',
  },
  {
    locale: 'en-AI',
    language: 'LANGUAGE.EN_AI',
  },
  {
    locale: 'en-AG',
    language: 'LANGUAGE.EN_AG',
  },
  {
    locale: 'en-AU',
    language: 'LANGUAGE.EN_AU',
  },
  {
    locale: 'en-BS',
    language: 'LANGUAGE.EN_BS',
  },
  {
    locale: 'en-BB',
    language: 'LANGUAGE.EN_BB',
  },
  {
    locale: 'en-BE',
    language: 'LANGUAGE.EN_BE',
  },
  {
    locale: 'en-BZ',
    language: 'LANGUAGE.EN_BZ',
  },
  {
    locale: 'en-BM',
    language: 'LANGUAGE.EN_BM',
  },
  {
    locale: 'en-BW',
    language: 'LANGUAGE.EN_BW',
  },
  {
    locale: 'en-IO',
    language: 'LANGUAGE.EN_IO',
  },
  {
    locale: 'en-VG',
    language: 'LANGUAGE.EN_VG',
  },
  {
    locale: 'en-BN',
    language: 'LANGUAGE.EN_BN',
  },
  {
    locale: 'en-BI',
    language: 'LANGUAGE.EN_BI',
  },
  {
    locale: 'en-CM',
    language: 'LANGUAGE.EN_CM',
  },
  {
    locale: 'en-CA',
    language: 'LANGUAGE.EN_CA',
  },
  {
    locale: 'en-KY',
    language: 'LANGUAGE.EN_KY',
  },
  {
    locale: 'en-CX',
    language: 'LANGUAGE.EN_CX',
  },
  {
    locale: 'en-CC',
    language: 'LANGUAGE.EN_CC',
  },
  {
    locale: 'en-CK',
    language: 'LANGUAGE.EN_CK',
  },
  {
    locale: 'en-DG',
    language: 'LANGUAGE.EN_DG',
  },
  {
    locale: 'en-DM',
    language: 'LANGUAGE.EN_DM',
  },
  {
    locale: 'en-ER',
    language: 'LANGUAGE.EN_ER',
  },
  {
    locale: 'en-ET',
    language: 'LANGUAGE.EN_ET',
  },
  {
    locale: 'en-FK',
    language: 'LANGUAGE.EN_FK',
  },
  {
    locale: 'en-FJ',
    language: 'LANGUAGE.EN_FJ',
  },
  {
    locale: 'en-GM',
    language: 'LANGUAGE.EN_GM',
  },
  {
    locale: 'en-GH',
    language: 'LANGUAGE.EN_GH',
  },
  {
    locale: 'en-GI',
    language: 'LANGUAGE.EN_GI',
  },
  {
    locale: 'en-GD',
    language: 'LANGUAGE.EN_GD',
  },
  {
    locale: 'en-GU',
    language: 'LANGUAGE.EN_GU',
  },
  {
    locale: 'en-GG',
    language: 'LANGUAGE.EN_GG',
  },
  {
    locale: 'en-GY',
    language: 'LANGUAGE.EN_GY',
  },
  {
    locale: 'en-HK',
    language: 'LANGUAGE.EN_HK',
  },
  {
    locale: 'en-IN',
    language: 'LANGUAGE.EN_IN',
  },
  {
    locale: 'en-IE',
    language: 'LANGUAGE.EN_IE',
  },
  {
    locale: 'en-IM',
    language: 'LANGUAGE.EN_IM',
  },
  {
    locale: 'en-IL',
    language: 'LANGUAGE.EN_IL',
  },
  {
    locale: 'en-JM',
    language: 'LANGUAGE.EN_JM',
  },
  {
    locale: 'en-JE',
    language: 'LANGUAGE.EN_JE',
  },
  {
    locale: 'en-KE',
    language: 'LANGUAGE.EN_KE',
  },
  {
    locale: 'en-KI',
    language: 'LANGUAGE.EN_KI',
  },
  {
    locale: 'en-LS',
    language: 'LANGUAGE.EN_LS',
  },
  {
    locale: 'en-LR',
    language: 'LANGUAGE.EN_LR',
  },
  {
    locale: 'en-MG',
    language: 'LANGUAGE.EN_MG',
  },
  {
    locale: 'en-MW',
    language: 'LANGUAGE.EN_MW',
  },
  {
    locale: 'en-MT',
    language: 'LANGUAGE.EN_MT',
  },
  {
    locale: 'en-MH',
    language: 'LANGUAGE.EN_MH',
  },
  {
    locale: 'en-MU',
    language: 'LANGUAGE.EN_MU',
  },
  {
    locale: 'en-FM',
    language: 'LANGUAGE.EN_FM',
  },
  {
    locale: 'en-MS',
    language: 'LANGUAGE.EN_MS',
  },
  {
    locale: 'en-NA',
    language: 'LANGUAGE.EN_NA',
  },
  {
    locale: 'en-NR',
    language: 'LANGUAGE.EN_NR',
  },
  {
    locale: 'en-NZ',
    language: 'LANGUAGE.EN_NZ',
  },
  {
    locale: 'en-NG',
    language: 'LANGUAGE.EN_NG',
  },
  {
    locale: 'en-NU',
    language: 'LANGUAGE.EN_NU',
  },
  {
    locale: 'en-NF',
    language: 'LANGUAGE.EN_NF',
  },
  {
    locale: 'en-MP',
    language: 'LANGUAGE.EN_MP',
  },
  {
    locale: 'en-PK',
    language: 'LANGUAGE.EN_PK',
  },
  {
    locale: 'en-PW',
    language: 'LANGUAGE.EN_PW',
  },
  {
    locale: 'en-PG',
    language: 'LANGUAGE.EN_PG',
  },
  {
    locale: 'en-PH',
    language: 'LANGUAGE.EN_PH',
  },
  {
    locale: 'en-PN',
    language: 'LANGUAGE.EN_PN',
  },
  {
    locale: 'en-PR',
    language: 'LANGUAGE.EN_PR',
  },
  {
    locale: 'en-RW',
    language: 'LANGUAGE.EN_RW',
  },
  {
    locale: 'en-WS',
    language: 'LANGUAGE.EN_WS',
  },
  {
    locale: 'en-SC',
    language: 'LANGUAGE.EN_SC',
  },
  {
    locale: 'en-SL',
    language: 'LANGUAGE.EN_SL',
  },
  {
    locale: 'en-SG',
    language: 'LANGUAGE.EN_SG',
  },
  {
    locale: 'en-SX',
    language: 'LANGUAGE.EN_SX',
  },
  {
    locale: 'en-SB',
    language: 'LANGUAGE.EN_SB',
  },
  {
    locale: 'en-SO',
    language: 'LANGUAGE.EN_SO',
  },
  {
    locale: 'en-ZA',
    language: 'LANGUAGE.EN_ZA',
  },
  {
    locale: 'en-SS',
    language: 'LANGUAGE.EN_SS',
  },
  {
    locale: 'en-SH',
    language: 'LANGUAGE.EN_SH',
  },
  {
    locale: 'en-KN',
    language: 'LANGUAGE.EN_KN',
  },
  {
    locale: 'en-LC',
    language: 'LANGUAGE.EN_LC',
  },
  {
    locale: 'en-VC',
    language: 'LANGUAGE.EN_VC',
  },
  {
    locale: 'en-SD',
    language: 'LANGUAGE.EN_SD',
  },
  {
    locale: 'en-SZ',
    language: 'LANGUAGE.EN_SZ',
  },
  {
    locale: 'en-TZ',
    language: 'LANGUAGE.EN_TZ',
  },
  {
    locale: 'en-TK',
    language: 'LANGUAGE.EN_TK',
  },
  {
    locale: 'en-TO',
    language: 'LANGUAGE.EN_TO',
  },
  {
    locale: 'en-TT',
    language: 'LANGUAGE.EN_TT',
  },
  {
    locale: 'en-TC',
    language: 'LANGUAGE.EN_TC',
  },
  {
    locale: 'en-TV',
    language: 'LANGUAGE.EN_TV',
  },
  {
    locale: 'en-UM',
    language: 'LANGUAGE.EN_UM',
  },
  {
    locale: 'en-VI',
    language: 'LANGUAGE.EN_VI',
  },
  {
    locale: 'en-UG',
    language: 'LANGUAGE.EN_UG',
  },
  {
    locale: 'en-GB',
    language: 'LANGUAGE.EN_GB',
  },
  {
    locale: 'en-US',
    language: 'LANGUAGE.EN_US',
  },
  {
    locale: 'en-VU',
    language: 'LANGUAGE.EN_VU',
  },
  {
    locale: 'en-ZM',
    language: 'LANGUAGE.EN_ZM',
  },
  {
    locale: 'en-ZW',
    language: 'LANGUAGE.EN_ZW',
  },
  {
    locale: 'fr-DZ',
    language: 'LANGUAGE.FR_DZ',
  },
  {
    locale: 'fr-AD',
    language: 'LANGUAGE.FR_AD',
  },
  {
    locale: 'fr-BE',
    language: 'LANGUAGE.FR_BE',
  },
  {
    locale: 'fr-BJ',
    language: 'LANGUAGE.FR_BJ',
  },
  {
    locale: 'fr-BF',
    language: 'LANGUAGE.FR_BF',
  },
  {
    locale: 'fr-BI',
    language: 'LANGUAGE.FR_BI',
  },
  {
    locale: 'fr-CM',
    language: 'LANGUAGE.FR_CM',
  },
  {
    locale: 'fr-CA',
    language: 'LANGUAGE.FR_CA',
  },
  {
    locale: 'fr-CF',
    language: 'LANGUAGE.FR_CF',
  },
  {
    locale: 'fr-TD',
    language: 'LANGUAGE.FR_TD',
  },
  {
    locale: 'fr-KM',
    language: 'LANGUAGE.FR_KM',
  },
  {
    locale: 'fr-CG',
    language: 'LANGUAGE.FR_CG',
  },
  {
    locale: 'fr-CD',
    language: 'LANGUAGE.FR_CD',
  },
  {
    locale: 'fr-CI',
    language: 'LANGUAGE.FR_CI',
  },
  {
    locale: 'fr-DJ',
    language: 'LANGUAGE.FR_DJ',
  },
  {
    locale: 'fr-GQ',
    language: 'LANGUAGE.FR_GQ',
  },
  {
    locale: 'fr-FR',
    language: 'LANGUAGE.FR_FR',
  },
  {
    locale: 'fr-GF',
    language: 'LANGUAGE.FR_GF',
  },
  {
    locale: 'fr-PF',
    language: 'LANGUAGE.FR_PF',
  },
  {
    locale: 'fr-GA',
    language: 'LANGUAGE.FR_GA',
  },
  {
    locale: 'fr-GP',
    language: 'LANGUAGE.FR_GP',
  },
  {
    locale: 'fr-GN',
    language: 'LANGUAGE.FR_GN',
  },
  {
    locale: 'fr-HT',
    language: 'LANGUAGE.FR_HT',
  },
  {
    locale: 'fr-IT',
    language: 'LANGUAGE.FR_IT',
  },
  {
    locale: 'fr-LB',
    language: 'LANGUAGE.FR_LB',
  },
  {
    locale: 'fr-LU',
    language: 'LANGUAGE.FR_LU',
  },
  {
    locale: 'fr-MG',
    language: 'LANGUAGE.FR_MG',
  },
  {
    locale: 'fr-ML',
    language: 'LANGUAGE.FR_ML',
  },
  {
    locale: 'fr-MQ',
    language: 'LANGUAGE.FR_MQ',
  },
  {
    locale: 'fr-MU',
    language: 'LANGUAGE.FR_MU',
  },
  {
    locale: 'fr-YT',
    language: 'LANGUAGE.FR_YT',
  },
  {
    locale: 'fr-MC',
    language: 'LANGUAGE.FR_MC',
  },
  {
    locale: 'fr-MA',
    language: 'LANGUAGE.FR_MA',
  },
  {
    locale: 'fr-NC',
    language: 'LANGUAGE.FR_NC',
  },
  {
    locale: 'fr-NE',
    language: 'LANGUAGE.FR_NE',
  },
  {
    locale: 'fr-RE',
    language: 'LANGUAGE.FR_RE',
  },
  {
    locale: 'fr-RW',
    language: 'LANGUAGE.FR_RW',
  },
  {
    locale: 'fr-SN',
    language: 'LANGUAGE.FR_SN',
  },
  {
    locale: 'fr-SC',
    language: 'LANGUAGE.FR_SC',
  },
  {
    locale: 'fr-BL',
    language: 'LANGUAGE.FR_BL',
  },
  {
    locale: 'fr-MF',
    language: 'LANGUAGE.FR_MF',
  },
  {
    locale: 'fr-PM',
    language: 'LANGUAGE.FR_PM',
  },
  {
    locale: 'fr-CH',
    language: 'LANGUAGE.FR_CH',
  },
  {
    locale: 'fr-SY',
    language: 'LANGUAGE.FR_SY',
  },
  {
    locale: 'fr-TG',
    language: 'LANGUAGE.FR_TG',
  },
  {
    locale: 'fr-TN',
    language: 'LANGUAGE.FR_TN',
  },
  {
    locale: 'fr-GB',
    language: 'LANGUAGE.FR_GB',
  },
  {
    locale: 'fr-VU',
    language: 'LANGUAGE.FR_VU',
  },
  {
    locale: 'fr-WF',
    language: 'LANGUAGE.FR_WF',
  },
  {
    locale: 'de-AT',
    language: 'LANGUAGE.DE_AT',
  },
  {
    locale: 'de-BE',
    language: 'LANGUAGE.DE_BE',
  },
  {
    locale: 'de-DK',
    language: 'LANGUAGE.DE_DK',
  },
  {
    locale: 'de-FR',
    language: 'LANGUAGE.DE_FR',
  },
  {
    locale: 'de-DE',
    language: 'LANGUAGE.DE_DE',
  },
  {
    locale: 'de-HU',
    language: 'LANGUAGE.DE_HU',
  },
  {
    locale: 'de-IT',
    language: 'LANGUAGE.DE_IT',
  },
  {
    locale: 'de-LI',
    language: 'LANGUAGE.DE_LI',
  },
  {
    locale: 'de-LU',
    language: 'LANGUAGE.DE_LU',
  },
  {
    locale: 'de-PL',
    language: 'LANGUAGE.DE_PL',
  },
  {
    locale: 'de-CH',
    language: 'LANGUAGE.DE_CH',
  },
  {
    locale: 'it-HR',
    language: 'LANGUAGE.IT_HR',
  },
  {
    locale: 'it-IT',
    language: 'LANGUAGE.IT_IT',
  },
  {
    locale: 'it-SM',
    language: 'LANGUAGE.IT_SM',
  },
  {
    locale: 'it-SI',
    language: 'LANGUAGE.IT_SI',
  },
  {
    locale: 'it-CH',
    language: 'LANGUAGE.IT_CH',
  },
  {
    locale: 'es-AR',
    language: 'LANGUAGE.ES_AR',
  },
  {
    locale: 'es-BO',
    language: 'LANGUAGE.ES_BO',
  },
  {
    locale: 'es-IC',
    language: 'LANGUAGE.ES_IC',
  },
  {
    locale: 'es-EA',
    language: 'LANGUAGE.ES_EA',
  },
  {
    locale: 'es-CL',
    language: 'LANGUAGE.ES_CL',
  },
  {
    locale: 'es-CO',
    language: 'LANGUAGE.ES_CO',
  },
  {
    locale: 'es-CR',
    language: 'LANGUAGE.ES_CR',
  },
  {
    locale: 'es-CU',
    language: 'LANGUAGE.ES_CU',
  },
  {
    locale: 'es-DO',
    language: 'LANGUAGE.ES_DO',
  },
  {
    locale: 'es-EC',
    language: 'LANGUAGE.ES_EC',
  },
  {
    locale: 'es-SV',
    language: 'LANGUAGE.ES_SV',
  },
  {
    locale: 'es-GQ',
    language: 'LANGUAGE.ES_GQ',
  },
  {
    locale: 'es-GT',
    language: 'LANGUAGE.ES_GT',
  },
  {
    locale: 'es-HN',
    language: 'LANGUAGE.ES_HN',
  },
  {
    locale: 'es-MX',
    language: 'LANGUAGE.ES_MX',
  },
  {
    locale: 'es-NI',
    language: 'LANGUAGE.ES_NI',
  },
  {
    locale: 'es-PA',
    language: 'LANGUAGE.ES_PA',
  },
  {
    locale: 'es-PY',
    language: 'LANGUAGE.ES_PY',
  },
  {
    locale: 'es-PE',
    language: 'LANGUAGE.ES_PE',
  },
  {
    locale: 'es-PR',
    language: 'LANGUAGE.ES_PR',
  },
  {
    locale: 'es-ES',
    language: 'LANGUAGE.ES_ES',
  },
  {
    locale: 'es-US',
    language: 'LANGUAGE.ES_US',
  },
  {
    locale: 'es-UY',
    language: 'LANGUAGE.ES_UY',
  },
  {
    locale: 'es-VE',
    language: 'LANGUAGE.ES_VE',
  },
]);

export const defaultDocumentLocaleLanguage: ILocaleLanguage = supportedDocumentLocalesLanguages.find(
  (localeLanguage: ILocaleLanguage) => localeLanguage.locale === 'en-US'
);

export function localeLanguagesLocalized(
  _translateService: TranslateService,
  localeLanguages: List<ILocaleLanguage>
): List<ILocaleLanguage> {
  return localeLanguages.map((localeLanguage) => {
    return {
      locale: localeLanguage.locale,
      language: _translateService.instant(localeLanguage.language),
    };
  }) as List<ILocaleLanguage>;
}
